// src/pages/Receipts.js
import React, { useEffect, useState, useCallback } from 'react';
import { getOrders, downloadReceiptPDF, saveBlob } from '../services/api';
import { T, fmt, Card, Empty, Spinner, SectionTitle, TH, TD } from '../components/UI';

export default function Receipts() {
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading]   = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await getOrders();
      setReceipts(r.data.data.filter(o => ['PAID','AWAITING_APPROVAL','PRINTING','PACKAGED','DISPATCHED','DELIVERED','CLOSED'].includes(o.status)));
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleDownload = async (o) => {
    try {
      const res = await downloadReceiptPDF(o.id);
      saveBlob(res.data, `RECEIPT-${o.order_number}.pdf`);
    } catch (e) {
      alert(e.response?.data?.message || 'Download failed. No receipt has been generated for this order yet.');
    }
  };

  if (loading) return <Spinner />;

  return (
    <div>
      <SectionTitle sub="Auto-generated when Bett confirms payment · No manual entry allowed">Receipt System</SectionTitle>
      <Card>
        {receipts.length === 0 ? <Empty msg="No receipts yet. Receipts are generated automatically when Bett confirms a payment." /> : (
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead><tr>
              <th style={TH}>Order</th><th style={TH}>Customer</th><th style={TH}>Amount</th><th style={TH}>Invoice</th><th style={TH}>Date</th><th style={TH}>Download</th>
            </tr></thead>
            <tbody>
              {receipts.map(o => (
                <tr key={o.id}>
                  <td style={{ ...TD, color:T.gold, fontWeight:700 }}>{o.order_number}</td>
                  <td style={TD}>{o.customer_name}</td>
                  <td style={{ ...TD, fontWeight:600, color:T.success }}>{fmt(o.total_amount)}</td>
                  <td style={{ ...TD, color:T.info, fontSize:'12px' }}>{o.invoice_number||'—'}</td>
                  <td style={{ ...TD, color:T.muted, fontSize:'12px' }}>{new Date(o.created_at).toLocaleDateString('en-KE')}</td>
                  <td style={TD}>
                    <button onClick={() => handleDownload(o)}
                      style={{ background:T.success, color:'#fff', border:'none', borderRadius:'6px', padding:'5px 12px', fontSize:'12px', fontWeight:700, cursor:'pointer' }}>
                      ⬇ Receipt PDF
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
